import { FlexColumn, isValidLatitude, isValidLongitude, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { StatefulPopover } from 'baseui/popover';
import { memo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { VEHICLE_TYPE_CAR } from '../../../constants/vehicle';
import { useCamera } from '../../../hooks/useCamera';
import { useStyles } from '../../../hooks/useStyles';
import { eventDetailState } from '../../../storage/gptStates';
import VehicleAssetIcon from '../../shared/VehicleAssetIcon';

function GptEventAlarmCSMarker() {
  const event = useRecoilValue(eventDetailState);
  const { zoomTo } = useCamera();
  const { css, theme } = useStyles();
  const { formatDateFromTs } = useMoment();
  const iconWrapper = css({ display: 'inline-block', lineHeight: 0 });

  if (!event) return null;

  if (!isValidLatitude(event.cs.latitude) || !isValidLongitude(event.cs.longitude)) return null;

  const { latitude, longitude, direction, geoReference, speed, timestamp } = event.cs;

  const onClick = () => {
    zoomTo({
      lat: latitude,
      lng: longitude,
    });
  };

  if (event.alarms.length === 0) {
    onClick();
  }

  return (
    <Marker
      longitude={event.cs.longitude}
      latitude={event.cs.latitude}
      rotation={direction || 0}
      onClick={onClick}
    >
      <StatefulPopover
        showArrow
        autoFocus={false}
        returnFocus
        placement="top"
        triggerType="hover"
        popoverMargin={-10}
        content={({ close }) => (
          <FlexColumn
            gap={theme.sizing.scale300}
            classNames={css({
              paddingRight: theme.sizing.scale600,
              paddingLeft: theme.sizing.scale600,
              paddingTop: theme.sizing.scale500,
              paddingBottom: theme.sizing.scale500,
            })}
          >
            <FlexColumn gap={theme.sizing.scale0}>
              <LabeledData
                label={'Dirección:'}
                content={geoReference}
              />
              <LabeledData
                label={'Última posición:'}
                content={`${formatDateFromTs(+timestamp)}`}
              />
              <LabeledData
                label={'Latitud:'}
                content={latitude.toString()}
              />
              <LabeledData
                label={'Longitud:'}
                content={longitude.toString()}
              />
              <LabeledData
                label={'Velocidad:'}
                content={`${speed} km/h`}
              />
            </FlexColumn>
          </FlexColumn>
        )}
        overrides={{
          Inner: {
            style: {
              backgroundColor: theme.colors.backgroundPrimary,
            },
          },
          Arrow: {
            style: {
              backgroundColor: theme.colors.backgroundPrimary,
            },
          },
        }}
      >
        <span className={iconWrapper}>
          <VehicleAssetIcon vehicleType={VEHICLE_TYPE_CAR} />
        </span>
      </StatefulPopover>
    </Marker>
  );
}

export default memo(GptEventAlarmCSMarker);
